import * as React from 'react';

type IconButtonProps = {
  testId?: string;
  iconClass: string;
  iconWeight?: string;
  isPressed?: boolean;
  title: string;
  disabled?: boolean;
  id?: string;
  classNames?: string;
  badgeText?: string | number;
  pulse?: boolean;
  type?: 'secondary' | 'danger';
  onClick: () => void;
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>;
};

const IconButton: React.FC<IconButtonProps> = ({
  testId,
  iconClass,
  iconWeight = 'fa-light',
  title,
  disabled,
  id,
  classNames = '',
  badgeText,
  pulse = false,
  isPressed = false,
  type = 'secondary',
  onClick,
  onMouseDown
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick();
  };

  return (
    <button
      id={id}
      className={`icon-button ${type} ${classNames} ${pulse ? 'primary-pulse' : ''} ${
        isPressed ? 'is-pressed' : ''
      }`}
      onClick={handleClick}
      onMouseDown={onMouseDown}
      title={title}
      disabled={disabled}
      data-badge-text={badgeText}
      data-testid={
        testId
          ? testId
          : `icon-button-${title.toLowerCase().replace(/\s+/g, '-')}`
      }
    >
      <i className={`${iconWeight} ${iconClass}`}></i>
    </button>
  );
};

export default IconButton;
